import React from 'react';
import PropTypes from 'prop-types';
import { Badge } from 'react-bootstrap';
import './SectionNavigation.css';

/**
 * SectionNavigation - Reusable section navigation tabs component
 * Following the EvaluationList design pattern
 */
const SectionNavigation = ({ sections, activeSection, onSectionChange, className = '' }) => {
    return (
        <div className={`section-navigation mb-4 ${className}`}>
            {sections.map((section) => (
                <button
                    key={section.key}
                    className={`section-btn ${activeSection === section.key ? 'active' : ''}`}
                    onClick={() => onSectionChange(section.key)}
                >
                    {section.icon && <i className={`bi bi-${section.icon} me-2`}></i>}
                    {section.label}
                    {section.badge !== undefined && section.badge > 0 && (
                        <Badge bg={section.badgeVariant || 'danger'} className="ms-2">
                            {section.badge}
                        </Badge>
                    )}
                </button>
            ))}
        </div>
    );
};

SectionNavigation.propTypes = {
    sections: PropTypes.arrayOf(
        PropTypes.shape({
            key: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
            icon: PropTypes.string,
            badge: PropTypes.number,
            badgeVariant: PropTypes.string
        })
    ).isRequired,
    activeSection: PropTypes.string.isRequired,
    onSectionChange: PropTypes.func.isRequired,
    className: PropTypes.string
};

export default SectionNavigation;